import { PaymentDetailsText } from "../PaymentDetailsText/PaymentDetailsText";
import { IPaymentOfferModel, IStateModel, ScriptStatus } from "@nf/common";

import { usePaymentDetails } from "../../hooks/usePaymentDetails";
import React, { useMemo } from "react";
import { PaymentDetailType } from "../../../../PaymentDetailType";

type TActiveSubscriptionsContainer = {
  scriptStatus: string | ScriptStatus;
};

export const ActiveOfferContainer: React.FC<
  TActiveSubscriptionsContainer
> = ({}) => {
  const { currentOffer, paymentDetails, subscriptions } = usePaymentDetails();

  const offerId = subscriptions?.[0]?.OfferId;

  const offer = useMemo(() => {
    return currentOffer && subscriptions && subscriptions[0] && offerId
      ? ((currentOffer as Record<string, IStateModel>)?.[offerId]
          ?.Data as IPaymentOfferModel)
      : undefined;
  }, [currentOffer, subscriptions, offerId]);

  return (
    <>
      <PaymentDetailType subscription={subscriptions?.[0]} offer={offer} />
      <div style={{ minHeight: "80px" }}>
        {paymentDetails && <PaymentDetailsText />}
      </div>
    </>
  );
};
